import React from "react";
import "../../Assets/Styles/pages/terms.scss";
import { Row } from "react-bootstrap";

const Refund: React.FC = () => {
  const refundContent = `
    <!DOCTYPE html>
    <html>
    <body>
    
    <p>Thank you for choosing eZy Watermark. We appreciate your business and are dedicated to providing you with the best possible watermarking experience on the web.</p>
    
    <h2>Subscriptions and Billing</h2>
    <p>eZy Watermark is a subscription-based web application offering both monthly and yearly plans. Subscriptions are billed in advance on a recurring monthly or yearly cycle (depending on the plan selected) and are automatically renewed unless canceled by the user.</p>
    
    <h2>No Refunds Policy</h2>
    <p>Except as required by applicable consumer protection laws, <strong>all sales are final</strong>. We do not offer refunds, pro-rated refunds, or credits for any monthly or yearly subscription fees once charged. This includes partial subscription periods, unused premium features, or unused days of an active subscription plan.</p>
    
    <h2>Cancellation Policy</h2>
    <p>You can cancel your subscription at any time. To cancel, please log in to your user account and navigate to your billing/subscription settings. Upon cancellation, your premium access will remain active until the end of your current billing period (monthly or yearly), and you will not be charged in the next billing cycle. No further payments will be processed after cancellation.</p>
    
    <h2>Third-Party Purchases (App Store & Google Play)</h2>
    <p>If you purchased your subscription through a mobile app store (such as the Apple App Store or Google Play Store), your subscription is managed entirely by the respective store. All billing questions, cancellations, and refund requests must be directed to Apple or Google support. Whizpool does not have the authority or access to issue refunds for subscriptions purchased through third-party platforms.</p>
    
    <h2>Contact Us</h2>
    <p>If you have any questions or concerns about our billing practices or this Refund Policy, please contact us at:</p>
    <p>eZy Watermark<br>
       Email: <a href="mailto:support@ezywatermark.com">support@ezywatermark.com</a>
    </p>
    
    <h6>Written/Updated: June 12, 2026</h6>
    
    </body>
    </html>`;

  return (
    <Row className="m-0 w-100 d-flex justify-content-center prouctSansLight text_16">
      <div
        className="w-75 text-start my-5 px-5"
        dangerouslySetInnerHTML={{ __html: refundContent }}
      />
    </Row>
  );
};

export default Refund;
